module.exports = __webpack_public_path__ + "assets/img/icon-upload.d68a5f7e.png";